import { render, staticRenderFns } from "./CustomerGroupDetail.vue?vue&type=template&id=77e9e82c"
import script from "./CustomerGroupDetail.vue?vue&type=script&lang=js"
export * from "./CustomerGroupDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports